export const COUNTRIES = {
  PA: { label: "🇵🇦 Panamá", timezone: "America/Panama", city: "Ciudad de Panamá" },
  VE: { label: "🇻🇪 Venezuela", timezone: "America/Caracas", city: "Caracas" },
  GT: { label: "🇬🇹 Guatemala", timezone: "America/Guatemala", city: "Ciudad de Guatemala" },
  DO: { label: "🇩🇴 República Dominicana", timezone: "America/Santo_Domingo", city: "Santo Domingo" },
};
export const COUNTRY_OPTIONS = Object.entries(COUNTRIES).map(([code, config]) => [code, config.label]);
export const COUNTRY_FILTER_OPTIONS = [["ALL", "Todos"], ...COUNTRY_OPTIONS];
const normalizedCode = value => typeof value === "string" ? value.trim().toUpperCase() : "";
const supported = code => Object.prototype.hasOwnProperty.call(COUNTRIES, code);
export function effectiveCountryCode(record) {
  const code = normalizedCode(record?.country_code);
  return supported(code) ? code : "PA";
}
export const countryLabel = code => COUNTRIES[effectiveCountryCode({country_code: code})].label;
export const countryTimeZone = code => COUNTRIES[effectiveCountryCode({country_code: code})].timezone;
export const countryCityPlaceholder = code => `Ej. ${COUNTRIES[effectiveCountryCode({country_code: code})].city}`;
export const matchesCountryFilter = (record, filter) => filter === "ALL" || effectiveCountryCode(record) === filter;
export function effectiveTargetCountries(record) {
  const raw = record?.countries;
  if (!Array.isArray(raw) || !raw.length) return ["PA"];
  const codes = raw.map(normalizedCode);
  return codes.every(supported) ? [...new Set(codes)] : ["PA"];
}
export function targetCountriesLabel(recordOrCountries) {
  const codes = effectiveTargetCountries(Array.isArray(recordOrCountries) ? { countries: recordOrCountries } : recordOrCountries);
  return codes.length === COUNTRY_OPTIONS.length ? "Todos los mercados" : codes.map(countryLabel).join(" + ");
}
export const matchesTargetFilter = (record, filter) => filter === "ALL" || effectiveTargetCountries(record).includes(filter);
